var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoImportarArquivos01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_upload_solid",
    transform: "translate(5 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M23.5,5.3c3.8,0,7,3.1,7,7s-3.1,7-7,7h-8.7v-8l0.5,0.5c0.7,0.7,1.8,0.7,2.5,0c0.7-0.7,0.7-1.8,0-2.5c0,0,0,0,0,0 l-3.5-3.5c-0.3-0.3-0.8-0.5-1.2-0.5h0c-0.4,0-0.9,0.2-1.2,0.5L8.3,9.3c-0.7,0.7-0.6,1.8,0,2.5c0.7,0.7,1.7,0.7,2.4,0l0.5-0.5v8h-7 c-4.8,0-8.7-3.9-8.7-8.7c0-4.4,3.2-8.1,7.5-8.6C5-3.6,10.9-6.5,16.4-4.6C20.6-3.2,23.5,0.8,23.5,5.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImportarArquivos01);
export default __webpack_public_path__ + "static/media/ico-importar-arquivos-01.6c4bba0fe40faf766197b1d216870ebf.svg";
export { ForwardRef as ReactComponent };